export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11704.a94a9af4.jpg";